import $ from 'jquery';
import Swiper from 'swiper';

'use strict';

function top_swiper() {
  var swiper = new Swiper('.slider-vertical', {
    direction: 'vertical',
    slidesPerView: 1,
    spaceBetween: 30,
    mousewheel: false,
    followFinger: false,
    allowTouchMove: false,
    touchReleaseOnEdges: true,
    forceToAxis: true,
    pagination: {
      el: '.pagination',
      clickable: true,
      // type: 'progressbar'
    },
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
  });
}

function gallery_swiper() {
  var galleryTop = new Swiper('.gallery-top', {
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  var galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 10,
    centeredSlides: true,
    slidesPerView: 'auto',
    touchRatio: 0.2,
    slideToClickedSlide: true,
  });

  if ($('.swiper-container.gallery-top')[0]) {
    galleryTop.controller.control = galleryThumbs;
    galleryThumbs.controller.control = galleryTop;
  }

}



// １．ページを読み込み後に処理を行う
if (!navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
  $(window).load(function() {
    // ２．imgタグに対して繰り返し処理を行う
    $('.blog-article img').each(function() {

      // ３．各要素のサイズ設定
      // ３.１．表示状態の画像の大きさ
      var img_height = $(this).height();
      var img_width = $(this).width();

      // ３.２．実際の画像の大きさ
      var img = new Image();
      img.src = $(this).attr('src');
      var _width = img.width;

      // ３.３．画面の横幅
      var device_width = $(window).width();

      // ４．縦長横長を判断する
      if ((img_width / img_height) >= 1) {
        // ４．１．横長の場合
        if (_width <= device_width) {
          $(this).css('width', '100%');
        } else {
          $(this).css('width', 'auto');
        }
      } else {
        // ４．２．縦長の場合
        if ($(this).width() >= device_width) {
          $(this).css('width', 'auto');
        } else {
          $(this).css('width', '50%');
        }
      }
    });
  });
}

// DOCUMENT READY //
$(document).ready(function() {
  top_swiper();
  gallery_swiper();
});

// WINDOW SCROLL //
$(window).scroll(function() {

});

// WINDOW RESIZE //
$(window).resize(function() {

});

window.onload = function() {
  var popup = document.getElementById('js-popup');
  if(!popup) return;
  popup.classList.add('is-show');

  var blackBg = document.getElementById('js-black-bg');
  var closeBtn = document.getElementById('js-close-btn');

  closePopUp(blackBg);
  closePopUp(closeBtn);

  function closePopUp(elem) {
    if(!elem) return;
    elem.addEventListener('click', function() {
      popup.classList.remove('is-show');
    })
  }
}

